import React from "react";
import { Send, ArrowRight } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";
import { useCommunityLinks } from "@/hooks/useCommunityLinks";
import api from "@/lib/api";

// Sitewide Telegram announcement bar. Single source of truth = Admin Link Manager
// (telegramLive flag + enabled Telegram link). LIVE = neon call-to-join.
// Not live = subtle "coming soon" strip. Never hardcodes the URL.
export default function TelegramTopBar() {
  const { data: settings } = useSettings();
  const { data: links = [] } = useCommunityLinks();
  const tg = links.find((l) => l.platform === "telegram");
  const url = (tg?.url || "").trim();
  const live = !!settings?.telegramLive && !!url;

  if (live) {
    return (
      <a
        href={url} target="_blank" rel="noreferrer"
        onClick={() => api.post("/analytics/event", { name: "official_link_click", meta: { id: "telegram", surface: "topbar" } }).catch(() => {})}
        data-testid="telegram-topbar-live"
        className="group block bg-neon text-black border-b-3 border-black hover:bg-neon/90 transition-colors">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 font-heading font-bold uppercase text-[11px] sm:text-xs tracking-wide">
          <Send className="w-4 h-4 shrink-0" />
          <span className="font-display font-900">Official $ROBBED Telegram Is Live</span>
          <span className="hidden sm:inline">— Join the community</span>
          <ArrowRight className="w-4 h-4 shrink-0 transition-transform group-hover:translate-x-0.5" />
        </div>
      </a>
    );
  }

  return (
    <div
      data-testid="telegram-topbar-soon"
      className="bg-ink3 text-dim border-b-3 border-black">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 font-mono text-[10px] sm:text-[11px] uppercase tracking-wide">
        <Send className="w-3.5 h-3.5 shrink-0 text-gold" />
        <span className="text-cream/80">Official Telegram</span>
        <span className="text-gold font-bold">Coming Soon</span>
      </div>
    </div>
  );
}
